import {post} from './http';

// One outbound delivery attempt to an external destination - a hopper's webhook/sheet target, or the
// P0 Slack alert webhook. Shared between hopper-configs.ts and p0SlackAlertConfig.ts, whose endpoints
// both expose a /delivery-actions resource of this shape.
export type DeliveryAction = {
  id: string;
  target_type: string;
  method: string | null;
  headers: Record<string, string> | null;
  body: string;
  created_at: string;
  stream_id: string | null;
  origin: string | null;
  status_code: number | null;
  outcome: string | null;
  // Why the destination refused, when it said (a sheet target's Sheets API error message).
  detail?: string | null;
  responded_at: string | null;
};

export const deliveryActionsApi = {
  resend: async (id: string) => post<undefined, DeliveryAction>(`/delivery-actions/${id}/resend`)
};
